import * as Views from "./views";

const Module = {
    name: "contoeconomicoattributionrules",
    defaultRoutePath: "/incomestatements/contoeconomicoattributionrule",
    menuItemScope: "incomestatements",
    menuItemName: "contoeconomicoattributionrules",
    routes: [
        {
            path: "/incomestatements/contoeconomicoattributionrule",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
